import PropTypes from "prop-types";
import React, { Fragment, useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { getDiscountPrice } from "../../helpers/product";
import Rating from "./sub-components/ProductRating";
import ProductModal from "./ProductModal";
import contentContext from '../../context/ContentContext'
import { tierCalculator } from '../../helpers/tier-pricing'

const ProductGridListSingle = ({
  product,
  currency,
  addToCart,
  addToWishlist,
  deleteFromWishlist,
  addToCompare,
  cartItem,
  wishlistItem,
  compareItem,
  sliderClassName,
  spaceBottomClass
}) => {
  const [modalShow, setModalShow] = useState(false);
  const { addToast } = useToasts();
  const [pricing, setPricing] = useState({});
  const selectedStore = useContext(contentContext);

  useEffect(() => {
    if (product?.data?.pricingManagement) {
      const productCostS = product?.data?.pricingManagement?.productCostS?.enabled
        ? product?.data?.pricingManagement?.productCostS
        : selectedStore?.storeData?.data?.pricingManagement?.productCostS;
      const stitchCount = product?.data?.pricingManagement?.stitchCount?.enabled
        ? product?.data?.pricingManagement?.stitchCount
        : selectedStore?.storeData?.data.pricingManagement?.stitchCount;
      const numberOfColors = product?.data?.pricingManagement?.numberOfColors?.enabled
        ? product?.data?.pricingManagement?.numberOfColors
        : selectedStore?.storeData?.data?.pricingManagement?.numberOfColors;
      setPricing({ productCostS, stitchCount, numberOfColors });
    }
  }, [selectedStore, product]);

  const calculateCost = (priceData, quantity, yItem, name) => {
    try {
      const calculateData = {
        quantity,
        P: priceData,
      };
      calculateData[name] = yItem;
      const resultProduct = tierCalculator.calculate(pricing[name], calculateData);
      return Number.isNaN(resultProduct) ? 0 : resultProduct;
    } catch (error) {
      return 0;
    }
  };

  const calculatePrice = (data, quantity, yItem, calculateName) => {
    return `$${calculateCost(data, quantity, yItem, calculateName)?.toFixed(2)}`;
  };

  return (
    <Fragment>
      <div
        className={`col-xl-4 col-sm-6 ${
          sliderClassName ? sliderClassName : ""
        }`}
      >
        <div
          className={`product-wrap ${spaceBottomClass ? spaceBottomClass : ""}`}
          style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
        >
          <div className="product-img" style={{width: "80%"}}>
            <Link to={process.env.PUBLIC_URL + "/product/" + product.id}>
              <img
                className="default-img customHeightOptions"
                width={100}
                height={300}
                src={product.data.productData.primaryImageUrl}
                alt=""
              />
            </Link>
              <div className="product-img-badges">
                {product.data.productOptions?.featuredProduct?.includes('New') && <span className="purple" style={{ textAlign: 'center' }}>New</span>}
                {product.data.productOptions?.featuredProduct?.includes('Best Seller') && <span className="pink" style={{ textAlign: 'center' }}>Best Seller</span>}
                {product.data.productOptions?.featuredProduct?.includes('Featured') && <span className="blue" style={{ textAlign: 'center' }}>Featured</span>}
              </div>

            <div className="product-action">
              <div className="pro-same-action pro-wishlist col-sm-3">
                <button
                  className={wishlistItem !== undefined ? "active" : ""}
                  // disabled={wishlistItem !== undefined}
                  title={
                    wishlistItem !== undefined
                      ? "Added to wishlist"
                      : "Add to wishlist"
                  }
                  onClick={() => {
                    if (wishlistItem !== undefined) {
                      deleteFromWishlist(product, addToast);
                    } else {
                      addToWishlist(product, addToast);
                    }
                  }}
                >
                  <i className={wishlistItem !== undefined ? "fa fa-heart" : "fa fa-heart-o"} />
                </button>
              </div>
              <div className="pro-same-action pro-cart col-sm-9">
              <button onClick={() => setModalShow(true)} title="Quick View2">
                  Quick View
                </button>
              </div>
              {/* <div className="pro-same-action pro-quickview">
                <button onClick={() => setModalShow(true)} title="Quick View">
                  <i className="pe-7s-look" />
                </button>
              </div> */}
            </div>
          </div>
          <div className="product-content text-center" style={{ display: 'flex',justifyContent: 'center' }}>
            <h3 style={{width: "80%"}}>
              <Link to={process.env.PUBLIC_URL + "/product/" + product.id}>
                {product.data.productData.productBrand ? product.data.productData.productBrand + ' - ' : ''}{product.data.productData.productName}
              </Link>
            </h3>
            {product.rating && product.rating > 0 ? (
              <div className="product-rating">
                <Rating ratingValue={product.rating} />
              </div>
            ) : (
              ""
            )}
            {/* <div className="product-price">
              {discountedPrice !== null ? (
                <Fragment>
                  <span>{currency.currencySymbol + finalDiscountedPrice}</span>{" "}
                  <span className="old">
                    {currency.currencySymbol + finalProductPrice}
                  </span>
                </Fragment>
              ) : (
                <span>{currency.currencySymbol + finalProductPrice} </span>
              )}
            </div> */}
          </div>
          <div className="product-list-price" style={{ textAlign: 'center'}}>
                    <b><span>${product?.data?.productData?.minimumPartPrice}</span></b>
                </div>
        </div>
        {/* <div className="shop-list-wrap mb-30">
          <div className="row">
            <div className="col-xl-4 col-md-5 col-sm-6">
              <div className="product-list-image-wrap">
                <div className="product-img">
                  <Link to={process.env.PUBLIC_URL + "/product/" + product.id}>
                    <img
                      className="default-img img-fluid"
                      src={product.data.productData.primaryImageUrl}
                      alt=""
                    />
                  </Link>
                  {product.discount || product.new ? (
                    <div className="product-img-badges">
                      {product.discount ? (
                        <span className="pink">-{product.discount}%</span>
                      ) : (
                        ""
                      )}
                      {product.new ? <span className="purple">New</span> : ""}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
            <div className="col-xl-8 col-md-7 col-sm-6">
              <div className="shop-list-content">
                <h3>
                  <Link to={process.env.PUBLIC_URL + "/product/" + product.id}>
                    {product.data.productData.productName}
                  </Link>
                </h3>
                <div className="product-list-price">
                  {discountedPrice !== null ? (
                    <Fragment>
                      <span>
                        {currency.currencySymbol + finalDiscountedPrice}
                      </span>{" "}
                      <span className="old">
                        {currency.currencySymbol + finalProductPrice}
                      </span>
                    </Fragment>
                  ) : (
                    <span>{currency.currencySymbol + finalProductPrice} </span>
                  )}
                </div>
                {product.rating && product.rating > 0 ? (
                  <div className="rating-review">
                    <div className="product-list-rating">
                      <Rating ratingValue={product.rating} />
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {product.shortDescription ? (
                  <p>{product.shortDescription}</p>
                ) : (
                  ""
                )}

                <div className="shop-list-actions d-flex align-items-center">
                  <div className="shop-list-btn btn-hover">

                      <Link
                        to={`${process.env.PUBLIC_URL}/product/${product.id}`}
                      >
                        Select Option
                      </Link>
                      <button
                        onClick={() => addToCart(product, addToast)}
                        className={
                          cartItem !== undefined && cartItem.quantity > 0
                            ? "active"
                            : ""
                        }
                        disabled={
                          cartItem !== undefined && cartItem.quantity > 0
                        }
                        title={
                          cartItem !== undefined
                            ? "Added to cart"
                            : "Add to cart"
                        }
                      >
                        {" "}
                        <i className="pe-7s-cart"></i>{" "}
                        {cartItem !== undefined && cartItem.quantity > 0
                          ? "Added"
                          : "Add to carts"}
                      </button>
                    
                  </div>

                  <div className="shop-list-wishlist ml-10">
                    <button
                      className={wishlistItem !== undefined ? "active" : ""}
                      disabled={wishlistItem !== undefined}
                      title={
                        wishlistItem !== undefined
                          ? "Added to wishlist"
                          : "Add to wishlist"
                      }
                      onClick={() => addToWishlist(product, addToast)}
                    >
                      <i className="pe-7s-like" />
                    </button>
                  </div>
                  <div className="shop-list-compare ml-10">
                    <button
                      className={compareItem !== undefined ? "active" : ""}
                      disabled={compareItem !== undefined}
                      title={
                        compareItem !== undefined
                          ? "Added to compare"
                          : "Add to compare"
                      }
                      onClick={() => addToCompare(product, addToast)}
                    >
                      <i className="pe-7s-shuffle" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </div>
      {/* product modal */}
      <ProductModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        product={product}
        currency={currency}
        cartitem={cartItem}
        price={product?.data?.productData?.minimumPartPrice}
        wishlistitem={wishlistItem}
        compareitem={compareItem}
        addtocart={addToCart}
        addtowishlist={addToWishlist}
        addtocompare={addToCompare}
        addtoast={addToast}
      />
    </Fragment>
  );
};

ProductGridListSingle.propTypes = {
  addToCart: PropTypes.func,
  addToCompare: PropTypes.func,
  addToWishlist: PropTypes.func,
  deleteFromWishlist: PropTypes.func,
  cartItem: PropTypes.object,
  compareItem: PropTypes.object,
  currency: PropTypes.object,
  product: PropTypes.object,
  sliderClassName: PropTypes.string,
  spaceBottomClass: PropTypes.string,
  wishlistItem: PropTypes.object
};

export default ProductGridListSingle;
